import type { Device } from "luxedo-data"
import { openOverlay } from "overlay"
import DeviceUpdateInformer from "./DeviceUpdateInformer.svelte"

export function openUpdateInformerOverlay(updateVersion: string, isBeta?: boolean) {
	openOverlay(DeviceUpdateInformer, {
		classHeading: "no-underline",
		props: {
			version: updateVersion,
			isBeta,
		},
	})
}
